import React from "react";
import styled from "@emotion/styled";

const BankAvatarImg = styled.img<{ size?: number }>`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.border.secondary};
  background: ${({ theme }) => theme.palette.common.white};
  max-height: ${({ size }) => (size ? `${size}px` : "24px")};
  max-width: ${({ size }) => (size ? `${size}px` : "24px")};

  ${({ theme }) => theme.breakpoints.up("sm")} {
    max-height: ${({ size }) => (size ? `${size}px` : "42px")};
    max-width: ${({ size }) => (size ? `${size}px` : "42px")};
  }
`;

export const BankAvatar = ({
  imgUrl,
  size,
}: {
  imgUrl?: string;
  size?: number;
}) => {
  if (!imgUrl) return null;

  return <BankAvatarImg src={imgUrl} size={size} />;
};
